import 'svelte/internal/disclose-version';

AdminMatches[$.FILENAME] = 'src/pages/AdminMatches.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import AdminNav from "../components/AdminNav.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { session } from "../lib/session.svelte.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<p class="unavailable svelte-i7dfv6"> </p>`), AdminMatches[$.FILENAME], [[104, 4]]);
var root_1 = $.add_locations($.from_html(`<p class="muted svelte-i7dfv6">Loading…</p>`), AdminMatches[$.FILENAME], [[123, 6]]);
var root_2 = $.add_locations($.from_html(`<span class="pill warn svelte-i7dfv6"> </span>`), AdminMatches[$.FILENAME], [[144, 18]]);

var root_3 = $.add_locations($.from_html(`<li><label class="svelte-i7dfv6"><input type="radio"/> <span class="body svelte-i7dfv6"><span class="name svelte-i7dfv6"> </span> <span class="addr svelte-i7dfv6"> </span> <span class="meta svelte-i7dfv6"><!> <em class="svelte-i7dfv6"> </em> <a target="_blank" rel="noopener noreferrer nofollow" class="svelte-i7dfv6">open on Google →</a></span></span></label></li>`), AdminMatches[$.FILENAME], [
	[
		150,
		18,
		[
			[
				151,
				20,
				[
					[152, 22],
					[
						153,
						22,
						[[154, 24], [155, 24], [156, 24, [[159, 26], [160, 26]]]]
					]
				]
			]
		]
	]
]);

var root_4 = $.add_locations($.from_html(`<article><header class="svelte-i7dfv6"><div><h3 class="svelte-i7dfv6"> </h3> <p class="ours svelte-i7dfv6"> </p></div> <!></header> <ul class="candidates svelte-i7dfv6"></ul> <footer class="svelte-i7dfv6"><button class="ghost svelte-i7dfv6">None of these</button> <button class="primary svelte-i7dfv6">Link selected</button></footer></article>`), AdminMatches[$.FILENAME], [
	[
		137,
		12,
		[
			[138, 14, [[139, 16, [[140, 18], [141, 18]]]]],
			[148, 14],
			[170, 14, [[171, 16], [174, 16]]]
		]
	]
]);

var root_5 = $.add_locations($.from_html(`<h2 class="svelte-i7dfv6"> <span class="count svelte-i7dfv6"> </span></h2> <!>`, 1), AdminMatches[$.FILENAME], [[134, 10, [[134, 28]]]]);

var root_6 = $.add_locations($.from_html(`<section class="sweeper svelte-i7dfv6"><div><strong> </strong> <strong> </strong> awaiting your decision</div> <div class="controls svelte-i7dfv6"><label class="svelte-i7dfv6">Search <input type="number" min="1" max="200" class="svelte-i7dfv6"/></label> <button class="primary svelte-i7dfv6"> </button></div></section> <!>`, 1), AdminMatches[$.FILENAME], [
	[
		106,
		4,
		[
			[107, 6, [[108, 8], [109, 10]]],
			[111, 6, [[112, 8, [[114, 10]]], [116, 8]]]
		]
	]
]);

var root_7 = $.add_locations(
	$.from_html(
		`<!> <p class="lede svelte-i7dfv6">Restaurants added by hand have no Google listing attached, so nothing can
    fetch their rating, reviews or photos. Searching proposes a match — you confirm it. Nothing is
    linked automatically: a wrong link shows another restaurant's content on this one and quietly
    renews itself every week.</p> <!>`,
		1
	),
	AdminMatches[$.FILENAME],
	[[96, 2]]
);

const $$css = {
	hash: 'svelte-i7dfv6',
	code: '\n  .lede.svelte-i7dfv6 { color: var(--ink-soft); font-size: 0.95rem; margin: 0 0 22px; max-width: 70ch; line-height: 1.55; }\n  .muted.svelte-i7dfv6 { color: var(--ink-soft); }\n  .unavailable.svelte-i7dfv6 { border: 1px solid #b3261e; color: #b3261e; border-radius: var(--radius); padding: 12px 16px; }\n\n  .sweeper.svelte-i7dfv6 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    background: var(--card);\n    padding: 14px 18px;\n    margin-bottom: 22px;\n    font-size: 0.9rem;\n  }\n  .controls.svelte-i7dfv6 { display: flex; gap: 10px; align-items: flex-end; }\n  .controls.svelte-i7dfv6 label:where(.svelte-i7dfv6) {\n    display: flex; flex-direction: column; gap: 4px;\n    font-size: 0.72rem; font-weight: 600; text-transform: uppercase;\n    letter-spacing: 0.04em; color: var(--ink-soft);\n  }\n  .controls.svelte-i7dfv6 input:where(.svelte-i7dfv6) {\n    width: 80px; padding: 7px 9px; border: 1px solid var(--line);\n    border-radius: 8px; background: var(--card-soft); color: var(--ink); font: inherit;\n  }\n\n  h2.svelte-i7dfv6 { font-size: 1.02rem; margin: 26px 0 12px; display: flex; align-items: center; gap: 9px; }\n  .count.svelte-i7dfv6 {\n    background: var(--card-soft); border: 1px solid var(--line); border-radius: var(--radius-pill);\n    padding: 1px 10px; font-size: 0.78rem; color: var(--ink-soft);\n  }\n\n  .match.svelte-i7dfv6 {\n    border: 1px solid var(--line); border-radius: var(--radius);\n    background: var(--card); padding: 15px 18px; margin-bottom: 12px;\n  }\n  .match.busy.svelte-i7dfv6 { opacity: 0.55; pointer-events: none; }\n  .match.svelte-i7dfv6 header:where(.svelte-i7dfv6) { display: flex; justify-content: space-between; gap: 14px; align-items: flex-start; flex-wrap: wrap; }\n  .match.svelte-i7dfv6 h3:where(.svelte-i7dfv6) { margin: 0; font-size: 1rem; }\n  .ours.svelte-i7dfv6 { margin: 2px 0 0; font-size: 0.83rem; color: var(--ink-soft); }\n  .pill.svelte-i7dfv6 {\n    border-radius: var(--radius-pill); padding: 2px 11px; font-size: 0.75rem;\n    font-weight: 600; border: 1px dashed var(--line); color: var(--ink-soft); white-space: nowrap;\n  }\n  .pill.warn.svelte-i7dfv6 { border-color: var(--accent); color: var(--accent); }\n\n  .candidates.svelte-i7dfv6 { list-style: none; margin: 12px 0 0; padding: 0; display: flex; flex-direction: column; gap: 6px; }\n  .candidates.svelte-i7dfv6 label:where(.svelte-i7dfv6) { display: flex; gap: 10px; align-items: flex-start; cursor: pointer; padding: 8px 10px; border-radius: 8px; }\n  .candidates.svelte-i7dfv6 label:where(.svelte-i7dfv6):hover { background: var(--card-soft); }\n  .body.svelte-i7dfv6 { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n  .name.svelte-i7dfv6 { font-weight: 600; font-size: 0.92rem; }\n  .addr.svelte-i7dfv6 { font-size: 0.83rem; color: var(--ink-soft); }\n  .meta.svelte-i7dfv6 { font-size: 0.78rem; color: var(--ink-soft); display: flex; gap: 10px; flex-wrap: wrap; align-items: baseline; }\n  .meta.svelte-i7dfv6 em:where(.svelte-i7dfv6) { font-style: italic; }\n  .meta.svelte-i7dfv6 a:where(.svelte-i7dfv6) { text-decoration: underline; }\n\n  .match.svelte-i7dfv6 footer:where(.svelte-i7dfv6) {\n    display: flex; justify-content: flex-end; gap: 8px;\n    margin-top: 12px; padding-top: 11px; border-top: 1px solid var(--line);\n  }\n  button.svelte-i7dfv6 { border-radius: var(--radius-pill); padding: 8px 18px; font-size: 0.87rem; font-weight: 600; cursor: pointer; }\n  .primary.svelte-i7dfv6 { background: var(--accent); color: #fff; border: 1px solid var(--accent); }\n  .ghost.svelte-i7dfv6 { background: transparent; color: var(--ink-soft); border: 1px solid var(--line); }\n  button.svelte-i7dfv6:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function AdminMatches($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, AdminMatches);
	$.append_styles($$anchor, $$css);

	const binding_group = [];
	let unmatched = $.tag($.state(0), 'unmatched');
	let proposals = $.tag($.state($.proxy([])), 'proposals');
	let loading = $.tag($.state(true), 'loading');
	let sweeping = $.tag($.state(false), 'sweeping');
	let busy = $.tag($.state(null), 'busy');
	let sweepLimit = $.tag($.state(25), 'sweepLimit');
	let chosen = $.tag($.state($.proxy({})), 'chosen');
	let unavailable = $.tag($.state(null), 'unavailable');
	const isAdmin = $.tag($.derived(() => $.strict_equals(session.user?.role, "admin")), 'isAdmin');

	// Ambiguous first — those are the ones that actually need a person.
	const ambiguous = $.tag($.derived(() => $.get(proposals).filter((p) => !p.confident)), 'ambiguous');

	const confident = $.tag($.derived(() => $.get(proposals).filter((p) => p.confident)), 'confident');

	async function reload() {
		$.set(loading, true);

		try {
			const data = (await $.track_reactivity_loss(api.matchQueue()))();

			$.set(unmatched, data.unmatched, true);
			$.set(proposals, data.proposals, true);

			// Preselect the top candidate so a confident row is one click, not two.
			$.set(chosen, Object.fromEntries($.get(proposals).map((p) => [p.restaurantId, p.candidates[0]?.id])), true);

			$.set(unavailable, null);
		} catch(error) {
			$.set(unavailable, error.message ?? "Matching unavailable.", true);
		} finally {
			$.set(loading, false);
		}
	}

	$.user_effect(() => {
		if ($.get(isAdmin)) reload();
	});

	async function sweep() {
		$.set(sweeping, true);

		try {
			const result = (await $.track_reactivity_loss(api.sweepMatches(Number($.get(sweepLimit)))))();

			toastSuccess(`Searched ${result.searched}: ${result.proposed} with candidates, ` + `${result.noCandidates} with none, ${result.apiCalls} API calls.`);
			(await $.track_reactivity_loss(reload()))();
		} catch(error) {
			toastError(error.message ?? "Sweep failed.");
		} finally {
			$.set(sweeping, false);
		}
	}

	async function accept(proposal) {
		const candidateId = $.get(chosen)[proposal.restaurantId];

		if (!candidateId) return;

		$.set(busy, proposal.restaurantId, true);

		try {
			(await $.track_reactivity_loss(api.acceptMatch(candidateId)))();
			$.set(proposals, $.get(proposals).filter((p) => $.strict_equals(p.restaurantId, proposal.restaurantId, false)), true);
			$.set(unmatched, Math.max(0, $.get(unmatched) - 1), true);
			toastSuccess(`${proposal.name} linked. Its rating and photos arrive on the next fetch.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't link that.");
		} finally {
			$.set(busy, null);
		}
	}

	async function dismiss(proposal) {
		$.set(busy, proposal.restaurantId, true);

		try {
			(await $.track_reactivity_loss(api.dismissMatch(proposal.restaurantId)))();
			$.set(proposals, $.get(proposals).filter((p) => $.strict_equals(p.restaurantId, proposal.restaurantId, false)), true);
			$.set(unmatched, Math.max(0, $.get(unmatched) - 1), true);
			toastSuccess(`${proposal.name} marked as not listed.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't dismiss that.");
		} finally {
			$.set(busy, null);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();

	$.head('i7dfv6', ($$anchor) => {
		$.effect(() => {
			$.document.title = 'Match listings · Upsorok admin';
		});
	});

	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			$.add_svelte_meta(
				() => EmptyState($$anchor, {
					title: 'Admins only',
					body: 'You need an admin account to match listings.'
				}),
				'component',
				AdminMatches,
				92,
				2,
				{ componentTag: 'EmptyState' }
			);
		};

		var alternate_2 = ($$anchor) => {
			var fragment_2 = root_7();
			var node_1 = $.first_child(fragment_2);

			$.add_svelte_meta(() => AdminNav(node_1, { current: 'matches' }), 'component', AdminMatches, 94, 2, { componentTag: 'AdminNav' });

			var node_2 = $.sibling(node_1, 4);

			{
				var consequent_1 = ($$anchor) => {
					var p_1 = root();
					var text = $.child(p_1, true);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text, $.get(unavailable)));
					$.append($$anchor, p_1);
				};

				var alternate_1 = ($$anchor) => {
					var fragment_3 = root_6();
					var section = $.first_child(fragment_3);
					var div = $.child(section);
					var strong = $.child(div);
					var text_1 = $.child(strong, true);

					$.reset(strong);

					var text_2 = $.sibling(strong);
					var strong_1 = $.sibling(text_2);
					var text_3 = $.child(strong_1, true);

					$.reset(strong_1);
					$.next();
					$.reset(div);

					var div_1 = $.sibling(div, 2);
					var label = $.child(div_1);
					var input = $.sibling($.child(label));

					$.remove_input_defaults(input);
					$.reset(label);

					var button = $.sibling(label, 2);
					var text_4 = $.child(button, true);

					$.reset(button);
					$.reset(div_1);
					$.reset(section);

					var node_3 = $.sibling(section, 2);

					{
						var consequent_2 = ($$anchor) => {
							var p_2 = root_1();

							$.append($$anchor, p_2);
						};

						var consequent_3 = ($$anchor) => {
							{
								let $0 = $.derived(() => $.strict_equals($.get(unmatched), 0) ? "Everything is matched" : "Nothing proposed yet");

								let $1 = $.derived(() => $.strict_equals($.get(unmatched), 0)
									? "Every restaurant is linked to a listing."
									: `Run a search to look up ${$.get(unmatched)} unmatched restaurant(s).`);

								$.add_svelte_meta(
									() => EmptyState($$anchor, {
										get title() {
											return $.get($0);
										},

										get body() {
											return $.get($1);
										}
									}),
									'component',
									AdminMatches,
									125,
									6,
									{ componentTag: 'EmptyState' }
								);
							}
						};

						var alternate = ($$anchor) => {
							var fragment_5 = $.comment();
							var node_4 = $.first_child(fragment_5);

							$.add_svelte_meta(
								() => $.each(
									node_4,
									17,
									() => [
										{ label: "Needs a decision", rows: $.get(ambiguous) },
										{ label: "Looks certain", rows: $.get(confident) }
									],
									$.index,
									($$anchor, group, $$index_2) => {
										var fragment_6 = $.comment();
										var node_5 = $.first_child(fragment_6);

										{
											var consequent_6 = ($$anchor) => {
												var fragment_7 = root_5();
												var h2 = $.first_child(fragment_7);
												var text_5 = $.child(h2);
												var span = $.sibling(text_5);
												var text_6 = $.child(span, true);

												$.reset(span);
												$.reset(h2);

												var node_6 = $.sibling(h2, 2);

												$.add_svelte_meta(
													() => $.each(node_6, 17, () => $.get(group).rows, (proposal) => proposal.restaurantId, ($$anchor, proposal, $$index_1) => {
														var article = root_4();
														let classes;
														var header = $.child(article);
														var div_2 = $.child(header);
														var h3 = $.child(div_2);
														var text_7 = $.child(h3, true);

														$.reset(h3);

														var p_3 = $.sibling(h3, 2);
														var text_8 = $.child(p_3);

														$.reset(p_3);
														$.reset(div_2);

														var node_7 = $.sibling(div_2, 2);

														{
															var consequent_4 = ($$anchor) => {
																var span_1 = root_2();
																var text_9 = $.child(span_1);

																$.reset(span_1);
																$.template_effect(() => $.set_text(text_9, `${$.get(proposal).candidates.length ?? ''} possible`));
																$.append($$anchor, span_1);
															};

															$.add_svelte_meta(
																() => $.if(node_7, ($$render) => {
																	if (!$.get(proposal).confident) $$render(consequent_4);
																}),
																'if',
																AdminMatches,
																143,
																16
															);
														}

														$.reset(header);

														var ul = $.sibling(header, 2);

														$.add_svelte_meta(
															() => $.each(ul, 21, () => $.get(proposal).candidates, (candidate) => candidate.id, ($$anchor, candidate) => {
																var li = root_3();
																var label_1 = $.child(li);
																var input_1 = $.child(label_1);

																$.remove_input_defaults(input_1);
																$.validate_binding('bind:group={chosen[proposal.restaurantId]}', [], () => $.get(chosen), () => $.get(proposal).restaurantId, 152, 42);

																var input_1_value;
																var span_2 = $.sibling(input_1, 2);
																var span_3 = $.child(span_2);
																var text_10 = $.child(span_3, true);

																$.reset(span_3);

																var span_4 = $.sibling(span_3, 2);
																var text_11 = $.child(span_4, true);

																$.reset(span_4);

																var span_5 = $.sibling(span_4, 2);
																var node_8 = $.child(span_5);

																{
																	var consequent_5 = ($$anchor) => {
																		var text_12 = $.text();

																		$.template_effect(($0) => $.set_text(text_12, `${$0 ?? ''} ★ (${$.get(candidate).reviewCount ?? 0 ?? ''})`), [() => $.get(candidate).rating.toFixed(1)]);
																		$.append($$anchor, text_12);
																	};

																	$.add_svelte_meta(
																		() => $.if(node_8, ($$render) => {
																			if ($.get(candidate).rating) $$render(consequent_5);
																		}),
																		'if',
																		AdminMatches,
																		157,
																		26
																	);
																}

																var em = $.sibling(node_8, 2);
																var text_13 = $.child(em, true);

																$.reset(em);

																var a = $.sibling(em, 2);

																$.reset(span_5);
																$.reset(span_2);
																$.reset(label_1);
																$.reset(li);

																$.template_effect(() => {
																	if (input_1_value !== (input_1_value = $.get(candidate).id)) {
																		input_1.value = (input_1.__value = $.get(candidate).id) ?? '';
																	}

																	$.set_text(text_10, $.get(candidate).name);
																	$.set_text(text_11, $.get(candidate).address);
																	$.set_text(text_13, $.get(candidate).reason);
																	$.set_attribute(a, 'href', $.get(candidate).sourceUrl);
																});

																$.bind_group(
																	binding_group,
																	[$$index_1, $$index_2],
																	input_1,
																	() => {
																		$.get(candidate).id;

																		return $.get(chosen)[$.get(proposal).restaurantId];
																	},
																	function set($$value) {
																		$.get(chosen)[$.get(proposal).restaurantId] = $$value;
																	}
																);

																$.append($$anchor, li);
															}),
															'each',
															AdminMatches,
															149,
															16
														);

														$.reset(ul);

														var footer = $.sibling(ul, 2);
														var button_1 = $.child(footer);
														var button_2 = $.sibling(button_1, 2);

														$.reset(footer);
														$.reset(article);

														$.template_effect(() => {
															classes = $.set_class(article, 1, 'match svelte-i7dfv6', null, classes, {
																busy: $.strict_equals($.get(busy), $.get(proposal).restaurantId)
															});

															$.set_text(text_7, $.get(proposal).name);
															$.set_text(text_8, `${($.get(proposal).address || "no address on file") ?? ''} · ${$.get(proposal).city ?? ''}`);
															button_1.disabled = $.strict_equals($.get(busy), $.get(proposal).restaurantId);
															button_2.disabled = $.strict_equals($.get(busy), $.get(proposal).restaurantId) || !$.get(chosen)[$.get(proposal).restaurantId];
														});

														$.delegated('click', button_1, function click() {
															return dismiss($.get(proposal));
														});

														$.delegated('click', button_2, function click_1() {
															return accept($.get(proposal));
														});

														$.append($$anchor, article);
													}),
													'each',
													AdminMatches,
													136,
													10
												);

												$.template_effect(() => {
													$.set_text(text_5, `${$.get(group).label ?? ''} `);
													$.set_text(text_6, $.get(group).rows.length);
												});

												$.append($$anchor, fragment_7);
											};

											$.add_svelte_meta(
												() => $.if(node_5, ($$render) => {
													if ($.get(group).rows.length) $$render(consequent_6);
												}),
												'if',
												AdminMatches,
												133,
												8
											);
										}

										$.append($$anchor, fragment_6);
									}
								),
								'each',
								AdminMatches,
								132,
								6
							);

							$.append($$anchor, fragment_5);
						};

						$.add_svelte_meta(
							() => $.if(node_3, ($$render) => {
								if ($.get(loading)) $$render(consequent_2); else if ($.strict_equals($.get(proposals).length, 0)) $$render(consequent_3, 1); else $$render(alternate, -1);
							}),
							'if',
							AdminMatches,
							122,
							4
						);
					}

					$.template_effect(() => {
						$.set_text(text_1, $.get(unmatched));

						$.set_text(text_2, ` restaurant${$.strict_equals($.get(unmatched), 1) ? "" : "s"} still unmatched
        · `);

						$.set_text(text_3, $.get(proposals).length);
						input.disabled = $.get(sweeping);
						button.disabled = $.get(sweeping) || $.strict_equals($.get(unmatched), 0);
						$.set_text(text_4, $.get(sweeping) ? "Searching…" : "Search for matches");
					});

					$.bind_value(
						input,
						function get() {
							return $.get(sweepLimit);
						},
						function set($$value) {
							$.set(sweepLimit, $$value);
						}
					);

					$.delegated('click', button, sweep);
					$.append($$anchor, fragment_3);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(unavailable)) $$render(consequent_1); else $$render(alternate_1, -1);
					}),
					'if',
					AdminMatches,
					103,
					2
				);
			}

			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(isAdmin)) $$render(consequent); else $$render(alternate_2, -1);
			}),
			'if',
			AdminMatches,
			91,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);